import { render, staticRenderFns } from "./DashItem.vue?vue&type=template&id=686fe940&scoped=true&"
import script from "./DashItem.vue?vue&type=script&lang=js&"
export * from "./DashItem.vue?vue&type=script&lang=js&"
import style0 from "./DashItem.vue?vue&type=style&index=0&id=686fe940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686fe940",
  null
  
)

export default component.exports